import React from 'react';
// eslint-disable-next-line react/prop-types
export default ({ children, ...rest }) => <button className="btn btn-xs btn-warning" {...rest}>{children}</button>;